import { FC } from "react";

const Dishes: FC = () => {
  return <div>Dishes</div>;
};

export default Dishes;
